import React from "react";

const CollectionFilter = ({ collection, selectedCollection, setFilter, theme }) => {
  //console.log("CollectionFilter ", collection.name, selectedCollection.name);
  const isSelected = collection?.name === selectedCollection?.name;
  const handleClick = () => {
    if (!isSelected) {
      console.log("set filter ", collection);
      setFilter(collection);
    }
  };

  const isThemePresent = !!theme?.primaryColor && !!theme?.backgroundColor;

  return (
    <div
      className={`m-[4px_5px_5px_4px] flex h-[40px] select-none items-center justify-center whitespace-nowrap rounded-[20px] px-5 text-[13px] capitalize tracking-[1px] ${
        isSelected
          ? "text-fontPrimary bg-primary"
          : isThemePresent
            ? "text-fontBackground bg-secondary"
            : "text-fontBackground bg-appGray"
      }`}
      onClick={handleClick}
    >
      {collection.name ? collection.name : "All Products"}
    </div>
  );
};

export default CollectionFilter;
